import ToggleButtonGroup from '../../components/common/ToggleButtonGroup/ToggleButtonGroup'
import {Box} from '@mui/material'
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined'
import PropTypes from 'prop-types'
const ToggleButton = ({toggleBtnOnSelectCallback, showTable, disableToggleBtn}) => {
  const toggleBtnDetails = [
    {
      tooltipProps: {title: 'Chart View'},
      toggleBtnProps: {value: 'chart', 'aria-label': 'chart', icon: <TimelineOutlinedIcon />}
    },
    {
      tooltipProps: {title: 'Table View'},
      toggleBtnProps: {value: 'table', 'aria-label': 'table', icon: <ViewListOutlinedIcon />}
    }
  ]
  return (
    <Box top='-6px' right='0px' position='absolute' width='fit-content' marginBottom='8px'>
      <ToggleButtonGroup
        toggleButtons={toggleBtnDetails}
        onSelection={toggleBtnOnSelectCallback}
        defaultValue={showTable ? 'table' : 'chart'}
        disabled={disableToggleBtn}
      />
    </Box>
  )
}
ToggleButton.propTypes = {
  toggleBtnOnSelectCallback: PropTypes.func,
  showTable: PropTypes.bool,
  disableToggleBtn: PropTypes.bool
}
export default ToggleButton
